import { t } from 'ttag';

const GETTEXT_ALL_FACILITIES = t`All facilities`;

const GETTEXT_ALL_PRIORITY = t`All priority`;

const GETTEXT_ALL_EVENT_TYPE = t`All event type`;

const GETTEXT_ALL_STUDIES = t`All studies`;

export {
  GETTEXT_ALL_FACILITIES,
  GETTEXT_ALL_PRIORITY,
  GETTEXT_ALL_EVENT_TYPE,
  GETTEXT_ALL_STUDIES,
};
